import { useMutation } from "@tanstack/react-query";
import { TagToUpdate } from "../types";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";
import { updateTag } from "../api/updateTag";
import { invalidateTagDetailsQuery } from "./useTagDetailsQuery";

type Params = {
  tagId: string;
  tag: TagToUpdate;
};

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useUpdateTagQuery = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ tag, tagId }: Params) => {
      const tagData = {
        ...tag,
        updatedAt: new Date(),
      };

      return await updateTag(tagId, tagData);
    },
    onSuccess: (_, variables) => {
      // Invalidate query and refetch Algolia
      invalidateTagDetailsQuery(String(variables.tagId));
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
    onError: (e) => console.error(e),
  });
};
